import Loader from "@/components/loader/Loader.vue";
import Dropdown from "@/components/dropdown/Dropdown.vue";
import InputText from "@/components/inputText/InputText.vue";
import DropdownSelect from "@/components/dropdownSelect/DropdownSelect.vue";
import Modal from "@/components/modal/Modal.vue";
import regex from "@/common/regex";
import storageKeys from "@/consts/storageKeys";
import DropDownSearch from "@/components/dropDownSearch/DropdownSearch.vue";
import { getLangsForSelect } from "@/utils";

export default {
  name: "Auth",
  inject: ["auth", "localization"],
  data() {
    return {
      mode: "new",
      users: [],
      loading: false,
      authError: false,
      form: {
        site: {
          control: "search-select",
          value: null,
          placeholder: "global.site",
          mode: "new",
          alias: "site"
        },
        login: {
          control: "input-text",
          value: null,
          validator: { required: true, disableRoot: true },
          placeholder: "authPage.login"
        },
        password: {
          control: "input-text",
          type: "password",
          value: null,
          validator: { required: true },
          placeholder: "authPage.password"
        },
        remember: {
          control: "checkbox",
          value: true,
          trueValue: true,
          falseValue: false,
          label: "authPage.saveCredentials", // saveCredentials удален из localization.json
          mode: "new"
        }
      },
      forgot: {
        show: false
      },
      lang: {
        active: null,
        list: null
      },
      siteHistory: []
    };
  },
  created() {
    this.lang.list = getLangsForSelect(this.$store.state.i18n.translations.en);

    const usersJson = localStorage.getItem(storageKeys.USERS);

    if (usersJson) {
      this.users = JSON.parse(usersJson);
    }

    if (this.users.length) {
      this.form.login.value = this.users[0].login;
    }

    const siteHistoryJson = localStorage.getItem(storageKeys.SITE_HISTORY);
    this.siteHistory = siteHistoryJson ? JSON.parse(siteHistoryJson) : [];

    if (this.siteHistory.length) {
      this.form.site.value = this.siteHistory[0].name;
    }

    this.lang.active = this.lang.list.find(
      item => item.name === this.$store.state.i18n.locale
    );

    this.$validator.extend("disableRoot", {
      getMessage: field => "customValidationError.disableRoot",
      validate: value => {
        return value.toLowerCase() !== "root";
      }
    });
  },
  computed: {
    formData() {
      return {
        site: this.form.site.value,
        login: this.form.login.value,
        password: this.form.password.value,
        remember: this.form.remember.value
      };
    }
  },
  watch: {
    form: {
      handler(form) {
        this.errors.items.forEach(item => {
          this.errors.removeById("backend");
        });
      },
      deep: true
    }
  },
  methods: {
    login: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;

          this.auth.login(this.formData).then(
            () => {
              this.loading = false;
              this.$router.push({ name: "views", params: { viewId: "main" } });
            },
            e => {
              switch (e.status) {
                case 400:
                  this.errors.add({
                    field: "password",
                    msg: "customValidationError.auth",
                    id: "backend"
                  });
                  break;
                case 401:
                  this.errors.add({
                    field: "password",
                    msg: "customValidationError.unauthorized",
                    id: "backend"
                  });
                  break;
              }

              this.loading = false;
            }
          );
        }
      });
    }
  },
  components: {
    Loader,
    Dropdown,
    DropdownSelect,
    InputText,
    Modal,
    DropDownSearch
  }
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth.js